"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "levico-terme": {
    "a555ff41": [{
      "hkey": "19d2aa82",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "levico": [{
      "hkey": "19d2aa82",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "efd1121b": [{
      "hkey": "884bcd37",
      "slug": "levico-terme",
      "name": "Levico Terme",
      "primary": true,
      "skipSearch": false
    }],
    "preghena": [{
      "hkey": "884bcd37",
      "slug": "levico-terme",
      "name": "Levico Terme",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c8f08e23": [{
      "hkey": "884bcd37",
      "slug": "levico-terme",
      "name": "Levico Terme",
      "primary": true,
      "skipSearch": false
    }],
    "scanna": [{
      "hkey": "884bcd37",
      "slug": "levico-terme",
      "name": "Levico Terme",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f63acf12": [{
      "hkey": "19d2aa82",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "selva": [{
      "hkey": "19d2aa82",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "levico-terme"
    }],
    "aad1f3fb": [{
      "hkey": "884bcd37",
      "slug": "levico-terme",
      "name": "Levico Terme",
      "primary": true,
      "skipSearch": false
    }],
    "varollo": [{
      "hkey": "884bcd37",
      "slug": "levico-terme",
      "name": "Levico Terme",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;